import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import getMaterie from "../../services/getMaterie";
import updateMateria from "../../services/updateMateria";
import getInsegnanti from "../../services/getInsegnanti";
import updateInsegnante from "../../services/updateInsegnante";

export default class EditInsegnante extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.section = this.props.section;
		if (this.section == undefined) {
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.state = {
			nome: "",
			cognome: "",
			isLoading: false,
		};
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		const currentInsegnante = cookies.get("currentInsegnante", { path: "/" });

		console.log("currentInsegnante", currentInsegnante);

		const insegnati = await getInsegnanti(username, token);

		const insegnante = insegnati.find(i => i.id == currentInsegnante);

		this.setState({
			id: insegnante.id,
			nome: insegnante.nome,
			cognome: insegnante.cognome,
		});

		console.log("insegnante", insegnante);
	}

	render() {
		return (
			<div>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={"Modifica insegnante"} />

					<TextInput
						name={"Nome"}
						value={this.state.nome}
						onChange={text => {
							this.setState({ nome: text });
						}}
					/>

					<TextInput
						name={"Cognome"}
						value={this.state.cognome}
						onChange={text => {
							this.setState({ cognome: text });
						}}
					/>

					<FixButton title={"Salva"} callback={this.save.bind(this)} />
				</LoadingOverlay>
			</div>
		);
	}

	async save() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		await updateInsegnante(username, token, this.state.id, this.state.nome, this.state.cognome);

		window.location.href = "/#/app/insegnanti";
	}
}
